import api from './api';

export const getRecipes = async ({ search, category, limit, offset } = {}) => {
  const params = {};
  if (search) params.search = search;
  if (category) params.category = category;
  if (limit) params.limit = limit;
  if (offset) params.offset = offset;

  const response = await api.get('/recipes', { params });
  return response.data;
};

export const getRecipeById = async (id) => {
  const response = await api.get(`/recipes/${id}`);
  return response.data;
};

export const createRecipe = async (recipeData) => {
  const response = await api.post('/recipes', recipeData);
  return response.data;
};

export const updateRecipe = async (id, recipeData) => {
  const response = await api.put(`/recipes/${id}`, recipeData);
  return response.data;
};

export const deleteRecipe = async (id) => {
  const response = await api.delete(`/recipes/${id}`);
  return response.data;
};

export const uploadRecipePhoto = async (recipeId, file, caption) => {
  const formData = new FormData();
  formData.append('photo', file);
  if (caption) formData.append('caption', caption);

  const response = await api.post(`/recipes/${recipeId}/photos`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};

export const setCoverPhoto = async (recipeId, photoId) => {
  const response = await api.put(`/recipes/${recipeId}/photos/${photoId}/cover`);
  return response.data;
};

export const deleteRecipePhoto = async (recipeId, photoId) => {
  const response = await api.delete(`/recipes/${recipeId}/photos/${photoId}`);
  return response.data;
};

export const emailRecipe = async (recipeId, to) => {
  const response = await api.post(`/recipes/${recipeId}/email`, { to });
  return response.data;
};

export const setStarterTemplate = async (recipeId, include) => {
  const response = await api.put(`/recipes/${recipeId}/starter-template`, { include });
  return response.data;
};

export const setWelcomeRecipe = async (recipeId, include) => {
  const response = await api.put(`/recipes/${recipeId}/welcome-recipe`, { include });
  return response.data;
};

export const scanRecipe = async (file) => {
  const formData = new FormData();
  formData.append('photo', file);
  const response = await api.post('/recipes/scan', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};

export const CATEGORIES = [
  { value: 'main', label: 'Main Dish' },
  { value: 'appetizer', label: 'Appetizer' },
  { value: 'soup', label: 'Soup' },
  { value: 'salad', label: 'Salad' },
  { value: 'breakfast', label: 'Breakfast' },
  { value: 'dessert', label: 'Dessert' },
  { value: 'asian', label: 'Asian' },
  { value: 'mexican', label: 'Mexican' },
  { value: 'mediterranean', label: 'Mediterranean' },
  { value: 'other', label: 'Other' },
];
